<template>
  <div class="cardTicketList-detail">
    <div class="msg">
      <div class="msg-header">
        <span>详情</span>
        <div class="submit">
          <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
        label-position="top"
        class="form"
      >
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7">
            <el-form-item label="姓名：" prop="userName">
              <el-input v-model="form.userName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="手机号：" prop="userPhone">
              <el-input v-model="form.userPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="性别：" prop="userSex">
              <el-select v-model="form.userSex" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7">
            <el-form-item label="生日：" prop="userBirthday">
              <el-date-picker
                v-model="form.userBirthday"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="城市：" prop="userCity">
              <el-cascader
                v-model="form.userCity"
                :options="pcaCodeList"
                :props="{expandTrigger:'click',value:'label'}"
                placeholder="请选择所在地区"
                style="width:100%;"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Email：" prop="userEmail">
              <el-input v-model="form.userEmail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="店铺" prop="shopName">
              <el-select v-model="form.shopName">
                <el-option
                  v-for="item in shopList"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.shopName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="record" v-if="form.id">
      <h1>积分记录:</h1>
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column prop="integralContent" label="内容" align="center"></el-table-column>
        <el-table-column prop="integralNum" label="积分" align="center"></el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import {
  getUser, updateUser, getAppIntegralRecordList, addUser,
} from '@/api/prefer';
import { validPhone, validEmail } from '@/utils/validate';
import Pagination from '@/components/Pagination';
import areaList from '@/utils/pc-code.json';
import { getShopList } from '@/api/brand';

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else if (validPhone(value)) {
        callback();
      }
      callback(new Error('手机号格式错误！'));
    };
    const validemail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (validEmail(value)) {
        callback();
      } else {
        callback(new Error('请输入正确格式'));
      }
    };
    return {
      pcaCodeList: areaList,
      options: [
        {
          value: 1,
          label: '男',
        },
        {
          value: 2,
          label: '女',
        },
      ],
      form: {
        id: '',
        userName: '',
        userPhone: '',
        userSex: '',
        userBirthday: '',
        userCity: '',
        userEmail: '',
        shopName: '',
      },
      rules: {
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        userPhone: [{ validator: validatePhone, trigger: 'blur' }],
        userSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        userBirthday: [
          { required: true, message: '请选择生日日期', trigger: 'blur' },
        ],
        userCity: [
          { required: true, message: '请选择所在城市', trigger: 'blur' },
        ],
        userEmail: [{ validator: validemail, trigger: 'blur' }],
      },
      tableData: [],
      tableLoading: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
      shopList: [],
    };
  },
  components: {
    Pagination,
  },
  async mounted() {
    await this.getShopList().catch(() => {});
    const { id } = this.$route.query;
    if (id) {
      this.getUser();
      this.getAppIntegralRecordList();
    }
  },
  methods: {
    // 获取详情
    getUser() {
      const { id } = this.$route.query;
      getUser(id).then((res) => {
        if (res.success && res.data) {
          const { userCity } = res.data;
          Object.keys(this.form).forEach((key) => {
            this.form[key] = res.data[key];
          });
          const [provice, city] = userCity.split(',');
          if (provice === city) {
            this.form.userCity = [city];
          } else {
            this.form.userCity = userCity.split(',');
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取积分记录列表
    getAppIntegralRecordList() {
      this.tableLoading = true;
      const { id } = this.$route.query;
      getAppIntegralRecordList({
        id,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          const { list, total } = res.data;
          this.tableData = list;
          this.total = total;
          this.tableLoading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 编辑
    updateUser() {
      this.loading = true;
      const { id } = this.$route.query;
      let { userCity } = this.form;
      this.form.id = id;
      userCity = userCity.length === 1 ? userCity.toString() : userCity.join(',');
      updateUser({ ...this.form, userCity }).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('编辑成功');
          this.$router.push({ name: 'PreferList' });
        }
      });
    },
    // 新增
    addUser() {
      this.loading = true;
      let { userCity } = this.form;
      userCity = userCity.length === 1 ? userCity.toString() : userCity.join(',');
      addUser({ ...this.form, userCity }).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('新增成功');
          this.$router.push({ name: 'PreferList' });
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            this.updateUser();
          } else {
            this.addUser();
          }

          return true;
        }
        return false;
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getAppIntegralRecordList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getAppIntegralRecordList();
    },
    handleCancel() {
      this.$router.push({ name: 'PreferList' });
    },
    getShopList() {
      return getShopList().then((res) => {
        if (res.success) {
          this.shopList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.cardTicketList-detail
  .msg-header
    flex-row()
    justify-content space-between
  .form
    // width 500px
    // margin 0 auto
  .msg
    border-bottom 1px solid #e8e8e8
    padding-bottom 24px
    h1
      margin-bottom 20px
      color rgba(0, 0, 0, 0.85)
      font-weight 700
      font-size 16px
      line-height 1.5
  .record
    margin-top 30px
    h1
      margin-bottom 16px
      color rgba(0, 0, 0, 0.85)
      font-weight 500
      font-size 16px
</style>
